import React from 'react';

/**
 * Lista de clientes con casillas. `companies` son las que se pueden elegir (para
 * un abogado, solo las de su despacho); `selected`, los ids marcados.
 */
function CompanyChecklist({ companies, selected, onChange, disabled }) {
  const toggle = id =>
    onChange(selected.includes(id) ? selected.filter(x => x !== id) : [...selected, id]);

  if (companies.length === 0) {
    return <p className='text-xs text-slate-500'>No hay clientes para elegir.</p>;
  }

  return (
    <div className='max-h-48 overflow-y-auto grid grid-cols-1 sm:grid-cols-2 gap-1 border border-slate-200 rounded-lg p-2'>
      {companies.map(c => (
        <label key={c._id} className='inline-flex items-center text-sm text-slate-700'>
          <input
            type='checkbox'
            className='h-4 w-4 rounded-lg border-slate-300 text-blue-600 focus:ring-blue-500'
            checked={selected.includes(c._id)}
            onChange={() => toggle(c._id)}
            disabled={disabled}
          />
          <span className='ml-2 truncate'>{c.username || c.usermail}</span>
        </label>
      ))}
    </div>
  );
}

export default CompanyChecklist;
